import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { canManageStandardsRelease, getStandardsReleases } from '../../lib/services/standardsReleases'

export function ReleasesListPage() {
  const { viewerContext } = useAuth()
  const canManage = canManageStandardsRelease(viewerContext?.is_superadmin === true)

  const { data, isLoading, error } = useQuery({
    queryKey: ['standards-releases'],
    queryFn: getStandardsReleases,
    enabled: canManage,
  })

  if (!canManage) {
    return (
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-900">
        Standards release management is restricted to Superadmin role.
      </div>
    )
  }

  const releases = data ?? []

  return (
    <div className="mx-auto max-w-5xl space-y-5">
      <header className="v11-workspace-header">
        <h1 className="font-brand text-2xl font-bold text-[var(--brand-deep)]">Standards Releases</h1>
        <p className="mt-1 text-sm text-slate-600">Superadmin release list, provenance, and publish/supersession controls.</p>
      </header>

      <section className="v11-section p-5">
        {isLoading && <p className="text-sm text-slate-500">Loading releases...</p>}
        {error && <p className="text-sm text-red-600">{(error as Error).message}</p>}
        {!isLoading && !error && releases.length === 0 && <p className="text-sm text-slate-500">No releases found.</p>}

        <div className="grid gap-3">
          {releases.map((release) => (
            <Link
              key={release.release_id}
              to={`/superadmin/releases/${release.release_id}`}
              className="v11-dashboard-card p-4"
            >
              <div className="flex items-center justify-between gap-3">
                <p className="text-sm font-bold text-slate-900">{release.release_id}</p>
                <span className={release.status === 'active' ? 'badge-released' : release.status === 'retired' ? 'badge-archived' : 'badge-in-progress'}>
                  {release.status}
                </span>
              </div>
              <p className="mt-1 text-xs text-slate-500">
                {release.framework_id} | v{release.version} | Effective {release.effective_date}
              </p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  )
}
